import cx from 'clsx';

import { InputOverrideClassNames } from '../../inputs';
import { InputStyleProps } from '../../inputs/types';

import classes from './GroupInput.module.css';

interface GroupInputStyleProps extends InputStyleProps {
  pos?: 'left' | 'right';
}

export const GroupInputOverrideClassNames = (props: GroupInputStyleProps) => {
  const inputClasses = InputOverrideClassNames(props);
  return {
    ...inputClasses,
    input: cx(inputClasses.input, {
      [classes.input]: !props.pos || props.pos === 'left',
      [classes.inputRight]: props.pos === 'right'
    })
  };
};
